import React ,{useEffect}from "react";
import AppRoutes from "../routes";
import InternationAcademy from "../pages/InternationalAcademy/Home";
import InternationAcademyAbout from "../pages/InternationalAcademy/About";
import OurSchool from "../pages/InternationalAcademy/OurSchool";
import Logo from '../assets/images/InternationalAcademy/logo.png'
import { Helmet } from "react-helmet";

const InternationalAcademyTemplate = () => {
  useEffect(() => {
    const favicon = document.getElementById("favicon");
    if (favicon) favicon.href = Logo;
  }, []);
  return (
    <>
      <Helmet>
        <title>International Academy School</title>
        <link
          rel="shortcut icon"
          type="image/jpg"
          href={Logo}
        />
      </Helmet>
      <div className="bg-[#ffffff] min-h-screen overflow-hidden">
        <AppRoutes
          homePage={InternationAcademy}
          aboutPage={InternationAcademyAbout}
          portfolioPage={OurSchool}
        />
      </div>
    </>
  );
};

export default InternationalAcademyTemplate;
